module.exports = __webpack_public_path__ + "img/analysis-results-update-desktop-fr.efef900a.jpg";